// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandedBox_root__oJDxU","titleDecoration":"BrandedBox_titleDecoration__aU_mW"};